import {useQuery} from "@tanstack/react-query";
import {OcSearchParamType} from "../interface";
import {readOverseas} from "../../../../../api/main/OcApi";
import {ocListMapInit} from "../state";

type Props = {
    param: OcSearchParamType;
};

export const useReadOverseas = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readOverseas", param],
        queryFn: async () => await readOverseas(param),
        select: (res) => res?.data.result ?? ocListMapInit,
    });

    return {data};
};
